function goodsTypesIcons(goodsType) {
	if (!goodsType) return 'order';
	switch (goodsType.iconId) {
	case 0:
		return 'order-pallet';
	case 1:
		return 'order-cold';
	case 2:
		return 'order-frozen';
	case 3:
		return 'order-heated';
	case 4:
		return 'order-fish';
	case 5:
		return 'order-gas';
	case 6:
		return 'order-explosive';
	case 7:
		return 'order-warning';
	case -1:
	default:
		return 'order';
	}
}

goodsTypesIcons.iconIds = Object.freeze({
	order: -1,
	pallet: 0,
	cold: 1,
	frozen: 2,
	heated: 3,
	fish: 4,
	gas: 5,
	explosive: 6,
	warning: 7,
});

goodsTypesIcons.getById = function(id) {
	switch (id) {
	case (this.iconIds.pallet):
		return 'order-pallet';
	case (this.iconIds.cold):
		return 'order-cold';
	case (this.iconIds.frozen):
		return 'order-frozen';
	case (this.iconIds.heated):
		return 'order-heated';
	case (this.iconIds.fish):
		return 'order-fish';
	case (this.iconIds.gas):
		return 'order-gas';
	case (this.iconIds.explosive):
		return 'order-explosive';
	case (this.iconIds.warning):
		return 'order-warning';
	case (this.iconIds.order):
	default:
		return 'order';
	}
};

module.exports = goodsTypesIcons;
